var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 px-3"},[_c('count-section',{staticClass:"mb-4"}),_c('our-projects-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }